<template>
  <div class="paddleContainer"></div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {}
  },
  computed: {
    ...mapState({
      email: state => state.userInfo?.email,
      user_id: state => state.userInfo?.id
    })
  },
  async mounted() {
    Paddle.Checkout.open({
      items: [{ priceId: 'pri_01jzapxsxjp0n38kesee3e0fgg', quantity: 1 }],
      customData: {
        account_email: this.email,
        user_id: this.user_id
      },
      customer: {
        email: this.email
      }
    })
  }
}
</script>
<style lang="scss">
.paddleContainer {
}
</style>
